export default "__VITE_ASSET__DpjxzZf3__"